// 9fbef606107a605d69c0edbcd8029e5d
import {
  buildUser,
  buildSession,
  buildPageContext,
  buildDeviceContext,
  buildContext,
  buildSelector,
  buildOptions,
  buildTrackEventContext,
  buildEngagements,
} from './dyRequestParts';

const buildDYRequest = ({
  userId,
  sessionId,
  pageType,
  pageLocation,
  referrer,
  locale,
  groups,
  userAgent,
  ip,
  dateTime,
  consent,
  data,
  pageAttributes,
}) => {
  const user = buildUser({ userId, consent });
  const session = buildSession(sessionId);
  const page = buildPageContext({ type: pageType, location: pageLocation, locale, data, referrer });
  const device = buildDeviceContext({ userAgent, ip, dateTime });
  const context = buildContext({ page, device, pageAttributes });
  const selector = buildSelector(groups);
  const options = buildOptions();

  return {
    user,
    session,
    context,
    selector,
    options,
  };
};

export const buildDYTrackRequest = ({
  userId,
  sessionId,
  userAgent,
  ip,
  dateTime,
  consent,
  recSlotId,
  decsId,
}) => {
  const user = buildUser({ userId, consent });
  const channel = 'web';
  const session = buildSession(sessionId);
  const device = buildDeviceContext({ userAgent, ip, dateTime });
  const context = buildTrackEventContext({ device, channel });
  const engagements = buildEngagements(recSlotId, decsId);

  return {
    user,
    session,
    context,
    engagements,
  };
};

export default buildDYRequest;
